export default () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9081_27982)">
      <g clipPath="url(#clip1_9081_27982)">
        <rect width="16" height="12" transform="translate(0 2)" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 2H16V14H11V2Z"
          fill="#F50100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2H6V14H0V2Z"
          fill="#2E42A5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 2H11V14H5V2Z"
          fill="#F7FCFF"
        />
      </g>
    </g>
    <rect
      x="0.5"
      y="2.5"
      width="15"
      height="11"
      rx="0.5"
      stroke="black"
      strokeOpacity="0.1"
      style={{ mixBlendMode: 'multiply' }}
    />
    <defs>
      <clipPath id="clip0_9081_27982">
        <rect y="2" width="16" height="12" rx="1" fill="white" />
      </clipPath>
      <clipPath id="clip1_9081_27982">
        <rect width="16" height="12" fill="white" transform="translate(0 2)" />
      </clipPath>
    </defs>
  </svg>
);
